import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";



class AvailableCourses extends Component {

    render() {
        return (

            <Paper style={{ width: "100%", overflowX: "auto", marginTop: "1%", marginBottom: "1%" }}>
                <Table>
                    <TableHead style={{ backgroundColor: "#13a89e" }}>
                        <TableRow><TableCell style={{ color: "white", fontSize: "large", fontWeight: "bold" }}>Available Course's</TableCell></TableRow></TableHead>
                    <TableBody>{this.props.allCourses && this.props.allCourses.length ? this.props.allCourses.map((data, index) => {
                        return <TableRow className="row" key={index}><TableCell style={{ fontSize: "20px", lineHeight: "2" }}>{data.name} {this.props.courseId.indexOf(data._id) === -1 ? <Button style={{ marginTop: "2px", float: "right", backgroundColor: "#13a89e", fontSize: "12px", border: "1px solid transparent", color: "#fff" }} onClick={() => this.props.checkClass(data)}> Join </Button> : <span style={{ color: "#13a89e", float: "right", paddingRight: "6px" }}>Joined</span>}</TableCell></TableRow>
                    }) : <TableRow><TableCell>Sorry no course available for you to join</TableCell></TableRow>}
                    </TableBody>
                </Table>
            </Paper>

            // For Card View

            // <Grid container style={{padding: "0", margin: "0", display: "flex", justifyContent: "space-around" }}>
            //     <Table style={{ marginTop: "2%" }}>
            //         <TableHead style={{ backgroundColor: "#6098f2" }}>
            //             <TableRow><TableCell style={{ color: "white", fontSize: "large", fontWeight: "bold" }}>Available Course's</TableCell></TableRow></TableHead>
            //     </Table>
            //         {this.props.allCourses && this.props.allCourses.length && this.props.allCourses.map((data, index) => {
            //             return <ItemGrid key={index}>
            //                 <Card className='card'>
            //                     <CardContent style={{textAlign : "center"}}>
            //                         <Typography component='p' style={{ fontSize: "20px", wordBreak : "break-word" }}>
            //                         {data.name}
            //                         </Typography>
            //                     </CardContent>
            //                     <CardActions style={{ display : "flex", justifyContent : "center", marginTop : "10%" }}>
            //                         {this.props.courseId.indexOf(data._id) === -1 ?
            //                             <Button size="medium" onClick={() => this.props.checkClass(data)} style={{ marginTop: "2px", backgroundColor: "#6098f2", fontSize: "16px", border: "1px solid transparent", color: "#fff" }}>Join</Button>
            //                             :
            //                             <Typography style={{ color: "#6098f2", paddingRight: "6px", fontSize: "50%", marginBottom: "10%" }}>Joined</Typography>
            //                         }
            //                     </CardActions>
            //                 </Card>
            //             </ItemGrid>
            //         })}
            // </Grid>
        )
    }
}

// function ItemGrid({ ...props }) {
//     const { classes, children, ...rest } = props;
//     return (
//         <Grid item {...rest} style={{ padding: "10px 15px 10px 5px" }} className="grid">
//             {children}
//         </Grid>
//     );
// }

export default AvailableCourses;


// xs={12} sm={12} md={6} lg={3} xl={3}


// WEBPACK FOOTER //
// ./src/container/AvailableCourses/availablecourses.js